import { NIGHTBOT_COMMAND_HANDLER } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { authenticationTypes } from 'root/src/shared/constants/auth'

export default {
	[NIGHTBOT_COMMAND_HANDLER]: {
		authentication: authenticationTypes.unauthenticated,
	},
}
